import React from 'react';
import { ValidatorForm} from 'react-material-ui-form-validator';
import MuiPickersUtilsProvider from "material-ui-pickers/utils/MuiPickersUtilsProvider";
import Picker from './Picker'
import MomentUtils from "material-ui-pickers/utils/moment-utils";
import moment from 'moment';
import 'moment/locale/fr';

moment.locale('fr');
class DateRangeDialog extends React.Component {
  constructor(props) {
    super(props)

    this.onChange = this.onChange.bind(this)
    this.onDismiss = this.onDismiss.bind(this)
  }

  onChange(date, id) {
    if(id === "dateStart")
      this.props.onChangeDateRange(date, this.props.dateEnd)

    if(id === "dateEnd")
      this.props.onChangeDateRange(this.props.dateStart, date)
  }

  onDismiss(e) {
    //console.log(e)
  }

  handleFormSubmit(e) {
    e.preventDefault()
  }

  render() {
    return (
      <div>
          <MuiPickersUtilsProvider locale="fr" moment={moment} utils={MomentUtils}>
              <ValidatorForm onSubmit={this.handleFormSubmit}>
                  <Picker
                      label="Date de début"
                      onChange={(e) => this.onChange(e, "dateStart")}
                      name="dateStart"
                      value={this.props.dateStart}
                      format={this.props.format ? this.props.format : "DD/MM/YYYY HH:mm"}
                      dateOnly={this.props.dateOnly}
                  />
                  <Picker
                      label="Date de fin"
                      onChange={(e) => this.onChange(e, "dateEnd")}
                      name="dateEnd"
                      value={this.props.dateEnd}
                      format={this.props.format ? this.props.format : "DD/MM/YYYY HH:mm"}
                      dateOnly={this.props.dateOnly}
                  />
              </ValidatorForm>
          </MuiPickersUtilsProvider>
      </div>
    );
  }
}

export default (DateRangeDialog);



// WEBPACK FOOTER //
// ./src/component/utils/DateRange.js